import { render, staticRenderFns } from "./TorrentStatus.vue?vue&type=template&id=ed753e20&lang=pug&"
import script from "./TorrentStatus.vue?vue&type=script&lang=js&"
export * from "./TorrentStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports